import avatar1 from 'assets/images/xs/avatar1.jpg';
import avatar2 from 'assets/images/xs/avatar2.jpg';
import avatar3 from 'assets/images/xs/avatar3.jpg';

export const membersData = [
    {
        memberImg: avatar1,
        memberName:'Amelia Green',
        memberEmail:'amelia.green@company.com'
    },
    {
        memberImg: avatar2,
        memberName:'Charlotte Green',
        memberEmail:'charlotte.green@company.com'
    },
    {
        memberImg: avatar3,
        memberName:'Susie Willis',
        memberEmail:'susie.willis@company.com'
    }
]